/**
 * Biopet Professional — aliases to page config helpers.
 */
import {
  BIOPET_ESSENTIAL_GRADE_PUBLIC_DIR as BIOPET_ESSENTIAL_GRADE_PUBLIC_DIR_BASE,
  BIOPET_ESSENTIAL_LABEL_TO_GRADE_IMAGE as BIOPET_ESSENTIAL_LABEL_TO_GRADE_IMAGE_BASE,
  biopetEssentialLabelToGradeFilename as biopetEssentialLabelToGradeFilenameBase,
  BIOPET_ESSENTIAL_PAGE5_GRADE as BIOPET_ESSENTIAL_PAGE5_GRADE_BASE,
  BIOPET_ESSENTIAL_PAGE6_GRADE as BIOPET_ESSENTIAL_PAGE6_GRADE_BASE,
  BIOPET_ESSENTIAL_PAGE7_GRADE as BIOPET_ESSENTIAL_PAGE7_GRADE_BASE,
  buildBiopetPage8SupplementBarSegments as buildBiopetPage8SupplementBarSegmentsBase,
  BIOPET_ESSENTIAL_PAGE8_SUPPLEMENT as BIOPET_ESSENTIAL_PAGE8_SUPPLEMENT_BASE
} from '../biopet_essential/Config_page_biopet_essential';

export const BIOPET_PROFESSIONAL_GRADE_PUBLIC_DIR = BIOPET_ESSENTIAL_GRADE_PUBLIC_DIR_BASE;
export const BIOPET_PROFESSIONAL_LABEL_TO_GRADE_IMAGE = BIOPET_ESSENTIAL_LABEL_TO_GRADE_IMAGE_BASE;
export const biopetProfessionalLabelToGradeFilename = biopetEssentialLabelToGradeFilenameBase;
export const BIOPET_PROFESSIONAL_PAGE5_GRADE = BIOPET_ESSENTIAL_PAGE5_GRADE_BASE;
export const BIOPET_PROFESSIONAL_PAGE6_GRADE = BIOPET_ESSENTIAL_PAGE6_GRADE_BASE;
export const BIOPET_PROFESSIONAL_PAGE7_GRADE = BIOPET_ESSENTIAL_PAGE7_GRADE_BASE;
export const buildBiopetProfessionalPage8SupplementBarSegments = buildBiopetPage8SupplementBarSegmentsBase;
export const BIOPET_PROFESSIONAL_PAGE8_SUPPLEMENT = BIOPET_ESSENTIAL_PAGE8_SUPPLEMENT_BASE;

// Backward-compatible aliases
export const BIOPET_ESSENTIAL_PAGE5_GRADE = BIOPET_PROFESSIONAL_PAGE5_GRADE;
export const BIOPET_ESSENTIAL_PAGE6_GRADE = BIOPET_PROFESSIONAL_PAGE6_GRADE;
export const BIOPET_ESSENTIAL_PAGE7_GRADE = BIOPET_PROFESSIONAL_PAGE7_GRADE;
export const BIOPET_ESSENTIAL_PAGE8_SUPPLEMENT = BIOPET_PROFESSIONAL_PAGE8_SUPPLEMENT;
export const biopetEssentialLabelToGradeFilename = biopetProfessionalLabelToGradeFilename;
export const buildBiopetPage8SupplementBarSegments = buildBiopetProfessionalPage8SupplementBarSegments;
